import React from 'react';
import './404.css';


function NoPage() {
    return (
        <div id="main">
            <div className="fof">
                    <h1>Error 404</h1>
                    <p>The page you are looking for does not exist.</p>
            </div>
        </div>
    );
}

export default NoPage;